export const ARRAY_OF_LEVEL = [
  "I know nothing about CTFs",
  "I have played CTFs sometimes",
  "I regularly play CTFs",
  "I am a Hacking Expert / Professional"
];
